<template>
  <div class="encyclopeDias marginAuto">
    <TopNavigation
      :TopAct="'3'"
    />
    <div :class="this.$store.state.webNavigator=='pc'?'':'pan110'">
      <listTopImg :imgType="'2'"/>
      <div class="marginAuto" :class="this.$store.state.webNavigator=='pc'?'max1720':''">
        <div>
          <videoPage
            :listType="informationType?informationType:''"
            :classType="'A8'"
            :active="types"
            :key="keys"
            :pageIndex="current"
            @getTotal="getTotal"
            :pageType="true"
            :toLeveListPath="toLeveListPath"
          />
          <Pagination :total="total" :display="9" :current-page='current' @pagechange="getPage" :key="pageKey"/>
        </div>
      </div>
    </div>

    <FooterNavigation/>
  </div>
</template>

<script>
import videoPage from '../listPage/videoPage/videoPage';
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import listTopImg from '../../components/listTopImg/listTopImg';
import Pagination from '../../components/Pagiantion/Pagination';
export default {
  name: 'encyclopeDias',
  components: {
    videoPage,
    TopNavigation,
    FooterNavigation,
    listTopImg,
    Pagination,
  },
  title () {
    return {
      title: '减肥视频|营养管理|体质管理|作息管理|健康饮食计划-脂玫乐(谷医坊)',
      keywords: '减肥营养管理，体质管理，作息管理，健康饮食计划',
      description: '脂玫乐减肥视频，提供减肥营养管理，减肥体质管理，作息管理视频，健康饮食计划等专业视频。',
    };
  },
  data () {
    return {
      imgtype: '1',
      TopAct: 1,
      informationType: '',
      keys: 1,
      pageKey: 2,
      types: '0',
      toLeveListPath: 'encyclopeDias',
      // 分页参数
      total: 1,
      current: 1,
      // 子栏目标题

    };
  },
  watch: {
    $route () {
      this.current = parseInt(this.$route.params.html.split("-")[2]);//page
      this.informationType = this.$route.params.html.split("-")[0];//id
      this.types = this.$route.params.html.split("-")[1];//type
      this.keys += 1;
      this.pageKey += 1;
    },
  },
  methods: {
    getTotal (data) {
      this.total = data;
    },
    getPage (data) {
      this.$router.push({path: '/' + this.$route.path.split('/')[1] + '/' + this.$route.params.html.split("-")[0] + '-' + this.$route.params.html.split("-")[1] + '-' + data + '-' + this.$route.params.html, });
    },
  },
  async asyncData ({store, route, app, }) {
  },
  mounted () {
    var arr = this.$route.params.html.split("-");
    this.current = parseInt(this.$route.params.html.split("-")[2]);//page
    this.informationType = this.$route.params.html.split("-")[0];//id
    this.types = this.$route.params.html.split("-")[1];//type
    this.keys += 1;
    this.pageKey += 1;
  },
  beforeDestroy () {

  },
  computed: {},
  created () {
  },
  filters: {},
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// encyclopeDias.vue